module.exports = __webpack_public_path__ + "static/media/documentation.0be1c736.svg";